import { useEffect, useState } from "react";
import api from "@/lib/api";

export function useMasters() {
  const [data, setData] = useState({
    fabric_types: [], age_categories: [], sleeve_types: [], colors: [],
    sizes: [], stores: [], marketplaces: [], warehouses: [],
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    Promise.all([
      api.get("/masters/fabric_types"),
      api.get("/masters/age_categories"),
      api.get("/masters/sleeve_types"),
      api.get("/masters/colors"),
      api.get("/masters/sizes"),
      api.get("/masters/stores"),
      api.get("/masters/marketplaces"),
      api.get("/inventory/warehouses"),
    ]).then((res) => {
      if (!alive) return;
      setData({
        fabric_types: res[0].data, age_categories: res[1].data, sleeve_types: res[2].data,
        colors: res[3].data, sizes: res[4].data, stores: res[5].data,
        marketplaces: res[6].data, warehouses: res[7].data,
      });
      setLoading(false);
    }).catch(() => setLoading(false));
    return () => { alive = false; };
  }, []);

  return { masters: data, loading };
}
